module.exports = __webpack_public_path__ + "assets/arrow_left_color.0c594ad7.svg";